import WorkItemFormCleanDataModel from "./WorkItemFormCleanDataModel";

const getCleanData = (form) =>
  form.cleanData
    .filter(
      (data) => typeof data.data === "string" || data.data instanceof String
    )
    .map((data) => new WorkItemFormCleanDataModel(data))
    .sort((a, b) => {
      if (a.label > b.label) {
        return 1;
      }
      if (b.label > a.label) {
        return -1;
      }
      return 0;
    });

class WorkItemFormModel {
  constructor(form) {
    this.createdOn = form.createdOn ? Date.parse(form.createdOn) : null;
    this.name = form.name || "";
    this.cleanData = getCleanData(form);
  }
}

export default WorkItemFormModel;
